import React, { useState, useEffect } from 'react'
import DefaultModal from '../Utils/DefaultModal'
import LoginComponent from '../Login/login'
import toast from 'react-hot-toast'
import { Alert } from '@mui/material'

const InvokeLogin = () => {

    const [open, setOpen] = useState(false)

    useEffect(() => {
        window.invokeLogin = (value) => setOpen(value)
    }, [])

    return (
        <DefaultModal
            open={open}
            title='Login'
            // handleClose={() => toast.error('Faça login novamente para não perder seu trabalho em andamento.')}
            content={
                <>
                    <Alert severity='info'>Sua sessão expirou, faça login novamente para não perder seu trabalho em andamento.</Alert>
                    <LoginComponent noRedirect />
                </>
            }
        />
    )

}

export default InvokeLogin